var _style, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect3, _rect4, _line, _line2, _path8, _polyline, _line3, _line4, _path9, _polyline2, _line5, _line6, _path10, _path11, _path12, _path13, _polygon, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#242C88;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#5E61A3;}\n\t.st4{opacity:0.5;fill:#242C88;}\n\t.st5{fill:#39C89A;}\n\t.st6{fill:#CAEAFB;}\n\t.st7{fill:#589FFF;}\n\t.st8{fill:#FF5751;}\n\t.st9{fill:#BC8D66;}\n\t.st10{opacity:0.7;fill:#FFFFFF;}\n\t.st11{fill:#F1C92A;}\n\t.st12{opacity:0.4;fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:#F3877E;}\n\t.st14{fill:#83D689;}\n\t.st15{opacity:0.4;fill:#242C88;}\n\t.st16{opacity:0.2;fill:#242C88;}\n\t\n\t\t.st17{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:0.1,6;}\n\t.st18{fill:#FFC408;}\n\t\n\t\t.st19{opacity:0.4;fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:0.1,6;}\n\t.st20{fill:none;stroke:#CAEAFB;stroke-width:12;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st21{fill:none;stroke:#CAEAFB;stroke-width:7;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st22{opacity:0.4;fill:none;stroke:#242C88;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st23{opacity:0.5;}\n\t.st24{fill:#242C88;}\n\t\n\t\t.st25{fill:none;stroke:#242C88;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:0.1,6;}\n\t.st26{opacity:0.5;fill:#FFFFFF;}\n\t.st27{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st28{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st29{fill:#E5BD9E;}\n\t.st30{fill:#A06D47;}\n\t\n\t\t.st31{opacity:0.3;fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:0.1,6;}\n\t.st32{opacity:0.1;fill:#242C88;}\n\t.st33{opacity:0.5;fill:#FF5751;}\n\t.st34{opacity:0.2;fill:none;stroke:#242C88;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st35{opacity:0.3;clip-path:url(#SVGID_2_);}\n\t\n\t\t.st36{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:0,6;}\n\t\n\t\t.st37{opacity:0.3;fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:0,6;}\n\t.st38{clip-path:url(#SVGID_4_);}\n\t.st39{opacity:0.2;fill:none;stroke:#242C88;stroke-width:9;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st40{opacity:0.3;}\n\t.st41{opacity:0.4;fill:#FFFFFF;}\n\t.st42{opacity:0.5;fill:#CAEAFB;}\n\t.st43{opacity:0.6;fill:#242C88;}\n\t.st44{opacity:0.5;fill:none;stroke:#242C88;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st45{opacity:0.3;fill:#242C88;}\n\t.st46{opacity:0.2;}\n\t\n\t\t.st47{clip-path:url(#SVGID_6_);fill:none;stroke:#242C88;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st48{opacity:0.2;fill:none;stroke:#FFFFFF;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st49{clip-path:url(#SVGID_8_);fill:#FFFFFF;}\n\t\n\t\t.st50{clip-path:url(#SVGID_8_);fill:none;stroke:#242C88;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st51{opacity:0.2;clip-path:url(#SVGID_8_);fill:#242C88;}\n\t\n\t\t.st52{opacity:0.2;clip-path:url(#SVGID_8_);fill:none;stroke:#242C88;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st53{fill:none;stroke:#242C88;stroke-width:1.848;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st54{opacity:0.4;fill:none;stroke:#FFFFFF;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st55{opacity:0.2;fill:none;stroke:#242C88;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st56{opacity:7.000000e-02;fill:#242C88;}\n\t.st57{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st58{opacity:0.4;fill:none;stroke:#FFFFFF;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st59{opacity:0.2;fill:none;stroke:#242C88;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st60{fill:none;stroke:#FF5751;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st61{fill:none;stroke:#242C88;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 83,
    width: 68,
    x: 11,
    y: 17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 83,
    width: 68,
    x: 11,
    y: 17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M33,46H23c-1.1,0-2-0.9-2-2V34c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v10C35,45.1,34.1,46,33,46z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M32.8,66H23c-1.1,0-2-0.9-2-2V54c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v9.8C35,65,34,66,32.8,66z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M33,87H23c-1.1,0-2-0.9-2-2V75c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v10C35,86.1,34.1,87,33,87z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33,46H23c-1.1,0-2-0.9-2-2V34c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v10C35,45.1,34.1,46,33,46z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32.8,66H23c-1.1,0-2-0.9-2-2V54c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v9.8C35,65,34,66,32.8,66z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33,87H23c-1.1,0-2-0.9-2-2V75c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v10C35,86.1,34.1,87,33,87z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M79,101V24H28c-1.1,0-2,0.9-2,2v75H79z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 83,
    width: 68,
    x: 31,
    y: 29
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 83,
    width: 68,
    x: 31,
    y: 29
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st34",
    x1: 63,
    x2: 75,
    y1: 53,
    y2: 53
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st34",
    x1: 63,
    x2: 87,
    y1: 48,
    y2: 48
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M54,58H44c-1.1,0-2-0.9-2-2V46c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v10C56,57.1,55.1,58,54,58z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "45.3,51.7 48.2,54.4 53.9,48.6 "
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st34",
    x1: 63,
    x2: 75,
    y1: 74,
    y2: 74
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st34",
    x1: 63,
    x2: 87,
    y1: 68,
    y2: 68
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M54,78H44c-1.1,0-2-0.9-2-2V66c0-1.1,0.9-2,2-2h9.8c1.2,0,2.2,1,2.2,2.2V76C56,77.1,55.1,78,54,78z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "45.3,71.9 48.2,74.6 53.9,68.9 "
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st34",
    x1: 63,
    x2: 75,
    y1: 94,
    y2: 94
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st34",
    x1: 63,
    x2: 87,
    y1: 89,
    y2: 89
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M54,98H44c-1.1,0-2-0.9-2-2V86c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v10C56,97.1,55.1,98,54,98z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54,58H44c-1.1,0-2-0.9-2-2V46c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v10C56,57.1,55.1,58,54,58z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54,78H44c-1.1,0-2-0.9-2-2V66c0-1.1,0.9-2,2-2h9.8c1.2,0,2.2,1,2.2,2.2V76C56,77.1,55.1,78,54,78z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54,98H44c-1.1,0-2-0.9-2-2V86c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v10C56,97.1,55.1,98,54,98z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "99,57.6 65.2,77.5 53.6,94.9 74.4,93.1 99,78.6 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "111.4,50.1 73.8,87.7 54.1,94.6 61,74.9 98.6,37.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    height: 18.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -18.9596 79.2808)",
    width: 53.2,
    x: 59.6,
    y: 53.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    height: 5.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -20.8293 83.7946)",
    width: 53.2,
    x: 64.1,
    y: 64.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "57.1,86 54.1,94.4 62.5,91.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "111.4,50.1 73.8,87.7 54.1,94.6 61,74.9 98.6,37.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M111.4,50.1l6-6c1.7-1.7,1.7-4.4,0-6l-6.8-6.8c-1.7-1.7-4.4-1.7-6,0l-6,6L111.4,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.4,50.1l6-6c1.7-1.7,1.7-4.4,0-6l-6.8-6.8c-1.7-1.7-4.4-1.7-6,0l-6,6L111.4,50.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 80.6,
    x2: 106.9,
    y1: 73.4,
    y2: 47.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 70,
    x2: 76.1,
    y1: 84,
    y2: 77.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 18.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -0.5282 86.9153)",
    width: 7.4,
    x: 100.9,
    y: 35.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    height: 18.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -0.5282 86.9153)",
    width: 7.4,
    x: 100.9,
    y: 35.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 18.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -0.5282 86.9153)",
    width: 7.4,
    x: 100.9,
    y: 35.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.253a36234fd5a6527934546614de9ed9.svg";
export { ForwardRef as ReactComponent };